import { TableCell } from '@mui/material';
import type React from 'react';
import styled from 'styled-components';
import type { TableColumnComponent } from '../../common/components/table/types';

export type EnabledIndicatorProps = Pick<TableColumnComponent, 'value'>;

const Indicator = styled.div<{ enabled: boolean }>`
  background-color: ${({ enabled }): string => (enabled ? '#5CD79B' : 'rgba(0, 0, 0, 0.26)')};
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
`;

const EnabledIndicator: React.FC<EnabledIndicatorProps> = ({ value }) => (
  <TableCell align="center">
    <Indicator enabled={Boolean(value)} title={value ? 'Content is enabled' : 'Content is disabled'} />
  </TableCell>
);

export default EnabledIndicator;
